var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { ChannelType } from '@amityco/js-sdk';
import useElement from '../../../core/hooks/useElement';
import ChatTypeSelector from '../../../chat/components/Chat/ChatTypeSelector';
import AvatarUploader from '../../../social/components/CommunityForm/AvatarUploader';
import Button from '../../../core/components/Button';
import UserSelector from '../../../social/components/UserSelector';
import { useAsyncCallback } from '../../../core/hooks/useAsyncCallback';
import { FormBlockBody, FormBlockContainer, TextInput, LabelContainer, LabelWrapper, ChatComposerContainer, Field, Label, Footer, Form, ControllerContainer, FormBody, SubmitButton, ErrorMessage, } from './styles';
const FormBlock = ({ children }) => (React.createElement(FormBlockContainer, null,
    React.createElement(FormBlockBody, null, children)));
const ChatComposer = ({ className, onCancel = () => { }, onSubmit = () => { } }) => {
    const { formatMessage } = useIntl();
    const defaultValues = {
        channelId: '',
        type: ChannelType.Live,
        displayName: undefined,
        avatarFileId: undefined,
        userIds: [],
        tags: [],
    };
    const { register, handleSubmit, watch, control, formState: { errors, isDirty }, } = useForm({
        defaultValues,
    });
    const userIds = watch('userIds', '');
    const [validateAndSubmit, submitting] = useAsyncCallback((data) => __awaiter(void 0, void 0, void 0, function* () {
        const payload = {
            channelId: (data === null || data === void 0 ? void 0 : data.channelId) || undefined,
            type: (data === null || data === void 0 ? void 0 : data.type) || ChannelType.Community,
            displayName: (data === null || data === void 0 ? void 0 : data.displayName) || undefined,
            avatarFileId: (data === null || data === void 0 ? void 0 : data.avatarFileId) || undefined,
            userIds: data === null || data === void 0 ? void 0 : data.userIds,
            tags: data === null || data === void 0 ? void 0 : data.tags,
        };
        yield onSubmit(payload);
    }));
    const disabled = !isDirty || userIds.length === 0 || submitting;
    const [formBodyRef, formBodyElement] = useElement();
    return (React.createElement(ChatComposerContainer, null,
        React.createElement(Form, { className: className, onSubmit: handleSubmit(validateAndSubmit) },
            React.createElement(FormBody, { ref: formBodyRef },
                React.createElement(FormBlock, null,
                    React.createElement(Field, null,
                        React.createElement(LabelWrapper, null,
                            React.createElement(LabelContainer, null,
                                React.createElement(Label, null,
                                    React.createElement(FormattedMessage, { id: "chatComposer.label.channelId" })))),
                        React.createElement(TextInput, Object.assign({}, register('channelId'), { placeholder: formatMessage({ id: 'chat_composer.placeholder.channelId' }), "data-qa-anchor": "chat-composer-channel-id-input" })),
                        React.createElement(ErrorMessage, { errors: errors, name: "channelId" })),
                    React.createElement(Field, null,
                        React.createElement(LabelWrapper, null,
                            React.createElement(LabelContainer, null,
                                React.createElement(Label, null,
                                    React.createElement(FormattedMessage, { id: "chatComposer.label.type" })))),
                        React.createElement(ControllerContainer, null,
                            React.createElement(Controller, { name: "type", rules: { required: 'Channel type is required' }, render: (_a) => {
                                    var _b = _a.field, { ref } = _b, rest = __rest(_b, ["ref"]);
                                    return (React.createElement(ChatTypeSelector, Object.assign({ parentContainer: formBodyElement }, rest)));
                                }, control: control, defaultValue: "" }))),
                    React.createElement(Field, null,
                        React.createElement(LabelWrapper, null,
                            React.createElement(LabelContainer, null,
                                React.createElement(Label, null,
                                    React.createElement(FormattedMessage, { id: "chatComposer.label.displayName" })))),
                        React.createElement(TextInput, Object.assign({}, register('displayName'), { placeholder: formatMessage({ id: 'chat_composer.placeholder.displayName' }), "data-qa-anchor": "chat-composer-display-name-input" })),
                        React.createElement(ErrorMessage, { errors: errors, name: "displayName" })),
                    React.createElement(Field, null,
                        React.createElement(Controller, { name: "avatarFileId", control: control, render: (_a) => {
                                var _b = _a.field, { ref } = _b, rest = __rest(_b, ["ref"]);
                                return (React.createElement(AvatarUploader, Object.assign({ mimeType: "image/png, image/jpeg" }, rest)));
                            }, defaultValue: null })),
                    React.createElement(Field, { error: errors.userIds },
                        React.createElement(Label, { name: "userIds", className: "required" },
                            React.createElement(FormattedMessage, { id: "chatComposer.addUsers" })),
                        React.createElement(Controller, { name: "userIds", render: (_a) => {
                                var _b = _a.field, { ref } = _b, rest = __rest(_b, ["ref"]);
                                return (React.createElement(UserSelector, Object.assign({ parentContainer: formBodyElement }, rest, { "data-qa-anchor": "chat-composer-select-user-input" })));
                            }, control: control }),
                        React.createElement(ErrorMessage, { errors: errors, name: "userIds" })))),
            React.createElement(Footer, null,
                React.createElement(Button, { onClick: (e) => {
                        e.preventDefault();
                        onCancel();
                    } },
                    React.createElement(FormattedMessage, { id: "cancel" })),
                React.createElement(SubmitButton, { "data-qa-anchor": "chat-composer-submit-button", disabled: disabled },
                    React.createElement(FormattedMessage, { id: "post" }))))));
};
export default ChatComposer;
//# sourceMappingURL=ChatComposer.js.map